export class ModernizrModule {

	constructor() {
		this.init();
	}

	init() {
		if (Modernizr.flexbox || Modernizr.flexboxtweener) {
			this.removeFrontpageHeaderFallback();
		} else {
			this.initFrontpageHeaderFallback();
		}
	}

	initFrontpageHeaderFallback() {
		$("[data-flex-remove]").remove();
		$("[data-flex-show]").addClass('no-flex');
	}

	removeFrontpageHeaderFallback() {
		$("[data-flex-show]").remove();
	}
}
